import React from 'react'
import Footer from '../../components/Footer'
import HomeHeader from '../../components/HomeHeader'
import Sidebar from '../../components/SideBar'
import SubscriptionContent from './components/SubscriptionContent'

const Subscription: React.FC = () => {
  return (
    <>
      <Sidebar />
      <HomeHeader />
      <SubscriptionContent />
      <Footer />
    </>
  )
}

export default Subscription
